// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lobby-view {
  height: 100%;
  background-color: #3c3c3c;
}

.lobby-view svg {
  max-width: 50%;
  /* max-height: 30vh; */
}

/* Override the button colors: */
.lobby-view .btn {
  background-color: #ffb700;
}
.lobby-view .btn-text {
  background: none;
  color: #ffb700;
}
/* .lobby-view .label {
  color: #ffb700;
} */

.lobby-view .lobby-container {
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing:border-box;
  justify-content: space-around;
}

.lobby-view .lobby-roomCode-box {
  margin-top: 20px;
}

.lobby-roomCode {
  font-size: 3rem;
}

.lobby-view .lobby-playersSection {
  background: #f8f8f8;
  padding: 30px 20px;
}

.lobby-playerList {
  /* margin-bottom: 40px; */
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(20ch, 1fr));
}

.lobby-playerList .lobby-player {
  margin: 5px;
}

.lobby-playerList .lobby-kickablePlayer {
  margin: 5px;
}

.lobby-playerList .lobby-kickablePlayer:hover {
  margin: 5px;
  text-decoration: line-through;
  cursor: pointer;

}

.lobby-playerList .lobby-kickablePlayer i {
  color: #aaa;
}

.lobby-waitingText {
  color: white;
}

.lobby-view .lobby-buttons {
  display:flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
}

.lobby-view .lobby-buttons button {
  width: 45%;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/style/lobby.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,eAAe;;AAEjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB","sourcesContent":[".lobby-view {\n  height: 100%;\n  background-color: #3c3c3c;\n}\n\n.lobby-view svg {\n  max-width: 50%;\n  /* max-height: 30vh; */\n}\n\n/* Override the button colors: */\n.lobby-view .btn {\n  background-color: #ffb700;\n}\n.lobby-view .btn-text {\n  background: none;\n  color: #ffb700;\n}\n/* .lobby-view .label {\n  color: #ffb700;\n} */\n\n.lobby-view .lobby-container {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  box-sizing:border-box;\n  justify-content: space-around;\n}\n\n.lobby-view .lobby-roomCode-box {\n  margin-top: 20px;\n}\n\n.lobby-roomCode {\n  font-size: 3rem;\n}\n\n.lobby-view .lobby-playersSection {\n  background: #f8f8f8;\n  padding: 30px 20px;\n}\n\n.lobby-playerList {\n  /* margin-bottom: 40px; */\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(20ch, 1fr));\n}\n\n.lobby-playerList .lobby-player {\n  margin: 5px;\n}\n\n.lobby-playerList .lobby-kickablePlayer {\n  margin: 5px;\n}\n\n.lobby-playerList .lobby-kickablePlayer:hover {\n  margin: 5px;\n  text-decoration: line-through;\n  cursor: pointer;\n\n}\n\n.lobby-playerList .lobby-kickablePlayer i {\n  color: #aaa;\n}\n\n.lobby-waitingText {\n  color: white;\n}\n\n.lobby-view .lobby-buttons {\n  display:flex;\n  align-items: center;\n  justify-content: space-around;\n  margin-bottom: 20px;\n}\n\n.lobby-view .lobby-buttons button {\n  width: 45%;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
